import {makeAutoObservable} from 'mobx';
import {showSnackbar, SnackbarType} from 'webapp-lib/Functions';
import {Order} from 'webapp-lib/typings';

import i18n from '_/i18n';

import {Loadable, State} from './types';

export const unexpectedError = (error?: unknown): void => {
  if (error && error !== 'string') {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  showSnackbar({
    text:
      typeof error === 'string'
        ? error
        : i18n.t('common:snackbar.error.unexpectedError'),
    type: SnackbarType.WARNING,
  });
};

export function sortProperties<T extends {columnName: string; order: Order}[]>(
  sort: T
): {
  sortFields: T[number]['columnName'][];
  sortOrders: Order[];
} {
  return {
    sortFields: sort.map(
      ({columnName}) => columnName as T[number]['columnName']
    ),
    sortOrders: sort.map(({order}) => order),
  };
}

export class SortLoadableData<SortKey, LoadableType>
  implements Loadable<LoadableType>
{
  public sort: {columnName: SortKey; order: Order}[];
  public data?: LoadableType;
  public state: State;
  public abort?: () => void;

  public constructor(defaultSortKey: SortKey) {
    makeAutoObservable(this, {}, {autoBind: true});

    this.sort = [
      {
        columnName: defaultSortKey,
        order: Order.Ascending,
      },
    ];
    this.state = State.Loading;
  }

  public setSort(newSort: {columnName: SortKey; order: Order}[]): void {
    this.sort = newSort;
  }
}
